import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Auto-refresh check: Prüft ob eine neue Version verfügbar ist
// Nur im Production-Modus aktiv
if (process.env.NODE_ENV === 'production') {
  // Speichere den aktuellen Build-Hash (wird beim Build durch Webpack ersetzt)
  const BUILD_TIME = process.env.REACT_APP_BUILD_TIME || Date.now().toString();
  
  // Prüfe alle 5 Minuten ob eine neue Version verfügbar ist
  const checkForUpdates = async () => {
    try {
      // Lade index.html mit Cache-Bypass
      const response = await fetch('/', { 
        cache: 'no-store',
        headers: { 'Cache-Control': 'no-cache' }
      });
      const html = await response.text();
      
      // Prüfe ob sich die geladenen JS-Dateien geändert haben
      const currentScripts = Array.from(document.scripts)
        .filter(s => s.src && s.src.includes('/static/js/'))
        .map(s => s.src);
      
      const newScripts = html.match(/\/static\/js\/[^"']+\.js/g) || [];
      
      // Wenn sich die Script-Namen geändert haben, gibt es ein Update
      const hasUpdate = newScripts.some(newScript => 
        !currentScripts.some(current => current.includes(newScript))
      );
      
      if (hasUpdate) {
        console.log('[App] Neue Version verfügbar, lade neu...');
        // Sanfter Reload ohne Benutzerunterbrechung
        window.location.reload();
      }
    } catch (e) {
      // Fehler ignorieren (z.B. Offline)
    }
  };
  
  // Starte Update-Check nach 30 Sekunden, dann alle 5 Minuten
  setTimeout(checkForUpdates, 30000);
  setInterval(checkForUpdates, 5 * 60 * 1000);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);
